import React, { memo } from 'react';
import { ButtonCTA } from '../components/ButtonCTA';
import { FAQAccordion } from '../components/FAQAccordion';
import { CountdownTimer } from '../components/CountdownTimer';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
import { CheckCircle2, Star, Clock, ShieldCheck, Sparkles, Moon, BookOpen, Heart, Activity, ArrowDown, Gift, Zap, Brain, Coffee, Leaf, Flame, Lock, Download, Award, Users, TrendingUp } from 'lucide-react';
export function LandingPage() {
  return <div className="min-h-screen bg-sand-50 font-sans text-earth-900 selection:bg-terracotta-100 selection:text-terracotta-700 overflow-x-hidden" data-id="element-36">
      {/* 1. Sticky Announcement Bar with Countdown - reverted */}
      <div className="sticky top-0 z-50 bg-gradient-to-r from-terracotta-700 via-terracotta-600 to-terracotta-700 text-white py-2.5 px-4 text-center shadow-lg border-b-2 border-gold-500" data-id="element-37">
        <div className="flex items-center justify-center gap-2 sm:gap-4 flex-wrap text-sm sm:text-base" data-id="element-38">
          <Flame className="w-4 h-4 sm:w-5 sm:h-5 text-gold-500 animate-pulse" data-id="element-39" />
          <span className="font-bold tracking-wide" data-id="element-40">
            Alivio para cuello, mandíbula, cabeza y espalda · 85% OFF — Termina
            en:
          </span>
          <CountdownTimer variant="bar" data-id="element-41" />
          <Flame className="w-4 h-4 sm:w-5 sm:h-5 text-gold-500 animate-pulse" data-id="element-42" />
        </div>
      </div>

      {/* Scarcity Bar */}
      <div className="bg-earth-900 text-sand-50 py-2 px-4 text-center text-xs sm:text-sm" data-id="element-43">
        <span className="inline-flex items-center gap-2 flex-wrap justify-center" data-id="element-44">
          <Users className="w-4 h-4 text-gold-500" data-id="element-45" />
          <span data-id="element-46">
            <span className="font-bold text-gold-500" data-id="element-47">347 personas</span> viendo
            esta página
          </span>
          <span className="hidden sm:inline text-earth-600" data-id="element-48">•</span>
          <span data-id="element-49">
            <span className="font-bold text-gold-500" data-id="element-50">73 vendidos HOY</span>
          </span>
          <span className="hidden sm:inline text-earth-600" data-id="element-51">•</span>
          <span data-id="element-52">
            <span className="font-bold text-gold-500" data-id="element-53">Solo 14 cupos</span> a
            este precio
          </span>
        </span>
      </div>

      {/* HERO — CRO-optimized: outcome + offer + mockup all above the fold */}
      <section className="relative pt-8 pb-10 lg:pt-12 lg:pb-14 px-4 overflow-hidden bg-gradient-to-b from-white to-sand-50" data-id="element-54">
        {/* Background blurs */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 pointer-events-none" data-id="element-55">
          <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] rounded-full bg-blush-100/50 blur-3xl" data-id="element-56"></div>
          <div className="absolute bottom-[-10%] left-[-10%] w-[600px] h-[600px] rounded-full bg-sage-100/40 blur-3xl" data-id="element-57"></div>
        </div>

        <div className="max-w-6xl mx-auto relative z-10 grid lg:grid-cols-2 gap-10 lg:gap-12 items-center" data-id="element-58">
          {/* LEFT: Copy + Offer */}
          <div className="space-y-5 text-center lg:text-left" data-id="element-59">
            {/* Commercial badge — clear offer */}
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-terracotta-600 text-white text-xs font-black tracking-wider uppercase shadow-md" data-id="element-60">
              <Flame className="w-3.5 h-3.5 text-gold-300" data-id="element-61" />
              85% OFF · Solo Hoy · Argentina
            </div>

            {/* Direct outcome H1 — no italic poetry */}
            <h1 className="text-4xl sm:text-5xl lg:text-[3.5rem] font-bold leading-[1.05] text-earth-900 tracking-tight" data-id="element-62">
              Frená el dolor de{' '}
              <span className="text-terracotta-700" data-id="element-63">
                cuello, mandíbula, cabeza y espalda
              </span>{' '}
              en 5 minutos al día.
            </h1>

            {/* Direct subhead */}
            <p className="text-base sm:text-lg text-earth-700 leading-relaxed" data-id="element-64">
              Aprendé los puntos exactos de auriculoterapia y reflexología que
              activan el alivio.{' '}
              <strong className="text-earth-900" data-id="element-65">
                Sin agujas, sin turnos, sin medicación.
              </strong>{' '}
              Desde tu casa.
            </p>

            {/* OFFER BOX — visible without scrolling */}
            <div className="bg-white border-2 border-terracotta-600 rounded-2xl p-4 sm:p-5 shadow-lg text-left max-w-md mx-auto lg:mx-0" data-id="element-66">
              <div className="flex items-center justify-between gap-3 mb-3 pb-3 border-b border-sand-200" data-id="element-67">
                <div data-id="element-68">
                  <p className="text-xs font-bold text-earth-500 uppercase tracking-wider" data-id="element-69">
                    Hoy lo llevás por
                  </p>
                  <div className="flex items-baseline gap-2 mt-1" data-id="element-70">
                    <span className="text-3xl sm:text-4xl font-black text-terracotta-700 leading-none" data-id="element-71">
                      $16.990
                    </span>
                    <span className="text-sm text-earth-500 line-through" data-id="element-72">
                      $111.920
                    </span>
                  </div>
                </div>
                <div className="text-right" data-id="element-73">
                  <span className="inline-block px-2.5 py-1 bg-gold-500 text-earth-900 text-[10px] font-black uppercase tracking-wider rounded" data-id="element-74">
                    Ahorrás
                  </span>
                  <p className="text-lg font-black text-terracotta-700 mt-1" data-id="element-75">
                    $94.930
                  </p>
                </div>
              </div>
              <ul className="space-y-1.5 text-sm text-earth-800" data-id="element-76">
                <li className="flex items-start gap-2" data-id="element-77">
                  <CheckCircle2 className="w-4 h-4 text-sage-600 mt-0.5 flex-shrink-0" data-id="element-78" />
                  <span data-id="element-79">2 ebooks (Reflexología + Auriculoterapia)</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-80">
                  <CheckCircle2 className="w-4 h-4 text-sage-600 mt-0.5 flex-shrink-0" data-id="element-81" />
                  <span data-id="element-82">6 bonus + Mapa completo de puntos</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-83">
                  <CheckCircle2 className="w-4 h-4 text-sage-600 mt-0.5 flex-shrink-0" data-id="element-84" />
                  <span data-id="element-85">Acceso inmediato por email · Pago único</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-86">
                  <CheckCircle2 className="w-4 h-4 text-sage-600 mt-0.5 flex-shrink-0" data-id="element-87" />
                  <span data-id="element-88">
                    <strong data-id="element-89">Garantía 7 días</strong> — Te devolvemos el 100% si
                    no sirve
                  </span>
                </li>
              </ul>
            </div>

            {/* CTA with PRICE in the button */}
            <div className="pt-1 flex flex-col items-center lg:items-start gap-3" data-id="element-90">
              <ButtonCTA text="QUIERO ACCEDER POR $16.990" subtext="Pago único · Acceso inmediato por email" showGuarantee data-id="element-91" />

              {/* Trust row */}
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-x-4 gap-y-2 text-sm text-earth-700" data-id="element-92">
                <div className="flex items-center gap-1.5" data-id="element-93">
                  <div className="flex text-gold-500" data-id="element-94">
                    {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 fill-current" data-id="element-95" />)}
                  </div>
                  <span className="font-semibold" data-id="element-96">4.9/5</span>
                </div>
                <span className="text-earth-300" data-id="element-97">·</span>
                <div className="flex items-center gap-1.5" data-id="element-98">
                  <Users className="w-4 h-4 text-sage-600" data-id="element-99" />
                  <span data-id="element-100">
                    <strong data-id="element-101">+2.000</strong> clientes
                  </span>
                </div>
                <span className="text-earth-300" data-id="element-102">·</span>
                <div className="flex items-center gap-1.5" data-id="element-103">
                  <ShieldCheck className="w-4 h-4 text-sage-600" data-id="element-104" />
                  <span data-id="element-105">
                    <strong data-id="element-106">Garantía 7 días</strong>
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT: Product Mockup */}
          <div className="relative" data-id="element-107">
            <div className="relative bg-gradient-to-br from-sand-100 via-blush-50 to-sage-50 rounded-3xl border border-sand-200 px-4 py-10 sm:py-12 overflow-hidden" data-id="element-108">
              <div className="absolute -top-10 -left-10 w-72 h-72 rounded-full bg-terracotta-200/40 blur-3xl pointer-events-none" data-id="element-109"></div>
              <div className="absolute -bottom-10 -right-10 w-80 h-80 rounded-full bg-sage-200/40 blur-3xl pointer-events-none" data-id="element-110"></div>

              <div className="relative flex items-center justify-center gap-3 sm:gap-6" data-id="element-111">
                <div className="absolute bottom-2 left-1/2 -translate-x-1/2 w-3/4 h-6 bg-earth-900/20 blur-2xl rounded-full" data-id="element-112"></div>

                <div className="relative" data-id="element-113">
                  <div className="absolute -inset-3 bg-gradient-to-tr from-sage-200 to-blush-200 rounded-3xl blur-2xl opacity-60 -z-10" data-id="element-114"></div>
                  <img src="https://cdn.magicpatterns.com/uploads/pZnPaA6mBGpi2qvCE38CQs/ALIVIO_EN_TUS_MANOS.png" alt="Ebook Alivio en tus Manos" className="w-36 sm:w-52 h-auto rounded-xl shadow-2xl rotate-[-6deg] hover:rotate-[-2deg] transition-transform duration-500" data-id="element-115" />
                </div>

                <div className="relative" data-id="element-116">
                  <div className="absolute -inset-3 bg-gradient-to-tr from-terracotta-200 to-gold-200 rounded-3xl blur-2xl opacity-60 -z-10" data-id="element-117"></div>
                  <img src="https://cdn.magicpatterns.com/uploads/oqinBveycV1kdDYFdFy3sd/iculoterapia.png" alt="Ebook Puntos que Sanan" className="w-36 sm:w-52 h-auto rounded-xl shadow-2xl rotate-[6deg] hover:rotate-[2deg] transition-transform duration-500" data-id="element-118" />
                </div>
              </div>

              <div className="relative mt-8 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-earth-700" data-id="element-119">
                <span className="flex items-center gap-1.5" data-id="element-120">
                  <Download className="w-4 h-4 text-terracotta-700" data-id="element-121" /> Acceso ya
                </span>
                <span className="text-earth-300" data-id="element-122">·</span>
                <span className="flex items-center gap-1.5" data-id="element-123">
                  <BookOpen className="w-4 h-4 text-sage-700" data-id="element-124" /> PDF + mapas
                </span>
                <span className="text-earth-300" data-id="element-125">·</span>
                <span className="flex items-center gap-1.5" data-id="element-126">
                  <Gift className="w-4 h-4 text-gold-600" data-id="element-127" /> + 6 bonus
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Authority/Trust strip — pulled UP from "por qué funciona" to build trust early */}
      <section className="bg-white border-y border-sand-200 py-5 px-4" data-id="element-128">
        <div className="max-w-5xl mx-auto grid grid-cols-2 sm:grid-cols-4 gap-4 sm:gap-6 text-center" data-id="element-129">
          <div className="flex flex-col items-center gap-1" data-id="element-130">
            <ShieldCheck className="w-5 h-5 text-sage-600" data-id="element-131" />
            <p className="text-xs sm:text-sm font-bold text-earth-900" data-id="element-132">
              Reconocido por la OMS
            </p>
            <p className="text-[10px] sm:text-xs text-earth-500" data-id="element-133">
              Auriculoterapia validada
            </p>
          </div>
          <div className="flex flex-col items-center gap-1" data-id="element-134">
            <BookOpen className="w-5 h-5 text-terracotta-700" data-id="element-135" />
            <p className="text-xs sm:text-sm font-bold text-earth-900" data-id="element-136">
              +2.500 años de práctica
            </p>
            <p className="text-[10px] sm:text-xs text-earth-500" data-id="element-137">
              Medicina tradicional china
            </p>
          </div>
          <div className="flex flex-col items-center gap-1" data-id="element-138">
            <Users className="w-5 h-5 text-sage-600" data-id="element-139" />
            <p className="text-xs sm:text-sm font-bold text-earth-900" data-id="element-140">
              +2.000 personas
            </p>
            <p className="text-[10px] sm:text-xs text-earth-500" data-id="element-141">
              ya lo están usando
            </p>
          </div>
          <div className="flex flex-col items-center gap-1" data-id="element-142">
            <Award className="w-5 h-5 text-gold-600" data-id="element-143" />
            <p className="text-xs sm:text-sm font-bold text-earth-900" data-id="element-144">
              Garantía 7 días
            </p>
            <p className="text-[10px] sm:text-xs text-earth-500" data-id="element-145">
              Devolución total
            </p>
          </div>
        </div>
      </section>

      {/* 3. Problem Section — pain agitation with vivid cost of inaction */}
      <section className="py-12 bg-earth-900 text-sand-50 px-4 relative overflow-hidden" data-id="element-146">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-full bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-terracotta-900/40 via-transparent to-transparent pointer-events-none" data-id="element-147"></div>

        <div className="max-w-4xl mx-auto text-center space-y-8 relative z-10" data-id="element-148">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-terracotta-100 leading-tight" data-id="element-149">
            El dolor crónico te está robando{' '}
            <span className="italic text-white" data-id="element-150">
              cosas que ni te das cuenta.
            </span>
          </h2>

          <p className="text-lg sm:text-xl text-sand-200 leading-relaxed max-w-2xl mx-auto" data-id="element-151">
            Cuello duro al despertar. Mandíbula apretada. Cabeza que late.
            Espalda que no afloja. Y arriba de eso, todo lo que{' '}
            <strong className="text-white" data-id="element-152">deja de ser igual</strong>:
          </p>

          {/* Vivid cost-of-inaction grid */}
          <div className="grid sm:grid-cols-2 gap-3 max-w-3xl mx-auto text-left" data-id="element-153">
            {['Te despertás cansado aunque dormiste 8 horas', 'Te perdés los planes que te gustaban', 'Te pones irritable con la gente que querés', 'Te falta concentración en el trabajo', 'Gastás plata en analgésicos que tapan el síntoma', 'Posponés cosas porque "te duele todo"'].map((item, i) => <div key={i} className="flex items-start gap-3 bg-earth-800/40 border border-earth-700 rounded-2xl px-4 py-3" data-id="element-154">
                <span className="text-terracotta-400 font-black text-lg leading-tight flex-shrink-0" data-id="element-155">
                  ✗
                </span>
                <p className="text-sand-200 text-sm sm:text-base leading-snug" data-id="element-156">
                  {item}
                </p>
              </div>)}
          </div>

          <p className="text-2xl sm:text-3xl font-bold text-white pt-2 leading-tight" data-id="element-157">
            Cada día que esperás, el dolor se hace{' '}
            <span className="text-terracotta-400" data-id="element-158">más crónico</span>.
          </p>
        </div>
      </section>

      {/* Comparison section — economic anchor */}
      <section className="py-10 px-4 bg-sand-50 relative" data-id="element-159">
        <div className="max-w-5xl mx-auto" data-id="element-160">
          <div className="text-center mb-8" data-id="element-161">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-terracotta-50 border border-terracotta-200 text-terracotta-700 text-xs sm:text-sm font-bold tracking-wide uppercase mb-4" data-id="element-162">
              <Sparkles className="w-3.5 h-3.5" data-id="element-163" />
              Mirá la diferencia
            </div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-earth-900 mb-3 leading-tight" data-id="element-164">
              $16.990 una vez vs.{' '}
              <span className="text-terracotta-600 italic" data-id="element-165">miles cada mes</span>
            </h2>
            <p className="text-base sm:text-lg text-earth-700 max-w-xl mx-auto" data-id="element-166">
              Una sesión de kinesiólogo cuesta más que todo este método junto. Y
              el dolor vuelve. Compará:
            </p>
          </div>

          <div className="bg-white rounded-3xl shadow-lg border border-sand-200 overflow-hidden" data-id="element-167">
            {/* Header row */}
            <div className="grid grid-cols-5 bg-earth-900 text-white text-xs sm:text-sm font-bold uppercase tracking-wider" data-id="element-168">
              <div className="p-4 sm:p-5 col-span-2" data-id="element-169">Lo que probaste</div>
              <div className="p-4 sm:p-5 text-center border-l border-earth-700" data-id="element-170">
                Costo
              </div>
              <div className="p-4 sm:p-5 text-center border-l border-earth-700" data-id="element-171">
                Resultados
              </div>
              <div className="p-4 sm:p-5 text-center border-l border-earth-700" data-id="element-172">
                En casa
              </div>
            </div>

            {[{
            name: 'Analgésicos',
            cost: '$8.000/mes',
            result: 'Apaga el síntoma',
            home: false
          }, {
            name: 'Kinesiólogo',
            cost: '$25.000/sesión',
            result: 'Mejora temporal',
            home: false
          }, {
            name: 'Videos de YouTube',
            cost: 'Gratis',
            result: 'Información dispersa',
            home: true
          }, {
            name: 'Tratamientos alternativos',
            cost: '$30.000+',
            result: 'Resultados variables',
            home: false
          }].map((row, i) => <div key={i} className="grid grid-cols-5 border-t border-sand-200 text-earth-800" data-id="element-173">
                <div className="p-4 sm:p-5 col-span-2 font-semibold" data-id="element-174">
                  {row.name}
                </div>
                <div className="p-4 sm:p-5 text-center text-sm border-l border-sand-200" data-id="element-175">
                  {row.cost}
                </div>
                <div className="p-4 sm:p-5 text-center text-sm border-l border-sand-200" data-id="element-176">
                  {row.result}
                </div>
                <div className="p-4 sm:p-5 text-center border-l border-sand-200" data-id="element-177">
                  {row.home ? <CheckCircle2 className="w-5 h-5 text-sage-500 mx-auto" data-id="element-178" /> : <span className="text-red-400 font-bold text-xl" data-id="element-179">✗</span>}
                </div>
              </div>)}

            {/* This product row — highlighted */}
            <div className="grid grid-cols-5 border-t-2 border-gold-500 bg-gradient-to-r from-gold-500/10 via-sand-50 to-gold-500/10 text-earth-900" data-id="element-180">
              <div className="p-4 sm:p-5 col-span-2 font-bold flex items-center gap-2" data-id="element-181">
                <Sparkles className="w-5 h-5 text-gold-500" data-id="element-182" />
                Este bundle
              </div>
              <div className="p-4 sm:p-5 text-center text-sm border-l border-sand-200 font-bold" data-id="element-183">
                $16.990 una vez
              </div>
              <div className="p-4 sm:p-5 text-center text-sm border-l border-sand-200 font-bold" data-id="element-184">
                Alivio duradero
              </div>
              <div className="p-4 sm:p-5 text-center border-l border-sand-200" data-id="element-185">
                <CheckCircle2 className="w-6 h-6 text-sage-600 mx-auto" data-id="element-186" />
              </div>
            </div>
          </div>

          <div className="mt-10 grid sm:grid-cols-3 gap-4" data-id="element-187">
            {[{
            label: 'Solo tus manos',
            sub: 'Sin agujas ni materiales'
          }, {
            label: '5 min al día',
            sub: 'Desde el sillón de tu casa'
          }, {
            label: 'Pago único',
            sub: 'Lo usás cuando lo necesites'
          }].map((item, i) => <div key={i} className="flex items-start gap-3 p-4 bg-white rounded-2xl border border-sand-200" data-id="element-188">
                <CheckCircle2 className="w-5 h-5 text-sage-600 flex-shrink-0 mt-0.5" data-id="element-189" />
                <div data-id="element-190">
                  <p className="font-bold text-earth-900" data-id="element-191">{item.label}</p>
                  <p className="text-sm text-earth-600" data-id="element-192">{item.sub}</p>
                </div>
              </div>)}
          </div>

          <div className="mt-12 flex justify-center" data-id="element-193">
            <ButtonCTA text="EMPEZAR HOY POR $16.990" subtext="Pago único · Garantía 7 días · Acceso inmediato" showGuarantee data-id="element-194" />
          </div>
        </div>
      </section>

      {/* 5. Product Breakdown — RESTORED with screenshot previews */}
      <section className="py-10 px-4 bg-sand-100 relative" data-id="element-195">
        <div className="max-w-6xl mx-auto space-y-12" data-id="element-196">
          <div className="text-center" data-id="element-197">
            <h2 className="text-3xl sm:text-4xl font-serif font-bold text-earth-900 mb-4" data-id="element-198">
              Todo lo que necesitás para frenar el dolor desde tu casa
            </h2>
            <p className="text-lg text-earth-600" data-id="element-199">
              2 ebooks + 6 bonus para atacar cuello, mandíbula, cabeza y espalda
              — en 5 minutos al día.
            </p>
          </div>

          {/* Ebook 1 — Reflexología */}
          <div className="space-y-8" data-id="element-200">
            <div className="grid md:grid-cols-2 gap-8 items-center bg-white p-6 sm:p-8 rounded-[2.5rem] shadow-sm border border-sand-200" data-id="element-201">
              <div className="order-2 md:order-1 space-y-6" data-id="element-202">
                <div className="inline-block px-4 py-1.5 bg-sage-100 text-sage-800 rounded-full text-sm font-bold tracking-wide" data-id="element-203">
                  EBOOK 1
                </div>
                <h3 className="text-3xl font-serif font-bold text-earth-900" data-id="element-204">
                  Alivio en tus Manos
                </h3>
                <p className="text-xl text-earth-600 font-serif italic" data-id="element-205">
                  Reflexología práctica para frenar el dolor físico desde casa
                </p>
                <ul className="grid sm:grid-cols-2 gap-2.5" data-id="element-206">
                  {['Migrañas', 'Dolor cervical', 'Dolor lumbar', 'Contracturas', 'Estrés físico', 'Insomnio', 'Dolor menstrual', 'Ansiedad'].map((item, i) => <li key={i} className="flex items-center gap-2 text-earth-700" data-id="element-207">
                      <CheckCircle2 className="w-5 h-5 text-sage-500" data-id="element-208" /> {item}
                    </li>)}
                </ul>
              </div>
              <div className="order-1 md:order-2 flex items-center justify-center relative" data-id="element-209">
                <div className="absolute inset-0 bg-gradient-to-tr from-sage-100 to-blush-100 rounded-3xl blur-2xl opacity-60 -z-10" data-id="element-210"></div>
                <img src="https://cdn.magicpatterns.com/uploads/pZnPaA6mBGpi2qvCE38CQs/ALIVIO_EN_TUS_MANOS.png" alt="Ebook Alivio en tus Manos — Reflexología" className="w-full max-w-sm h-auto rounded-2xl shadow-2xl rotate-[-3deg] hover:rotate-0 transition-transform duration-500" data-id="element-211" />
              </div>
            </div>
          </div>

          {/* Ebook 2 — Auriculoterapia */}
          <div className="space-y-8" data-id="element-212">
            <div className="grid md:grid-cols-2 gap-8 items-center bg-white p-6 sm:p-8 rounded-[2.5rem] shadow-sm border border-sand-200" data-id="element-213">
              <div className="flex items-center justify-center relative" data-id="element-214">
                <div className="absolute inset-0 bg-gradient-to-tr from-terracotta-100 to-blush-100 rounded-3xl blur-2xl opacity-60 -z-10" data-id="element-215"></div>
                <img src="https://cdn.magicpatterns.com/uploads/oqinBveycV1kdDYFdFy3sd/iculoterapia.png" alt="Ebook Puntos que Sanan — Auriculoterapia" className="w-full max-w-sm h-auto rounded-2xl shadow-2xl rotate-[3deg] hover:rotate-0 transition-transform duration-500" data-id="element-216" />
              </div>
              <div className="space-y-6" data-id="element-217">
                <div className="inline-block px-4 py-1.5 bg-terracotta-100 text-terracotta-800 rounded-full text-sm font-bold tracking-wide" data-id="element-218">
                  EBOOK 2
                </div>
                <h3 className="text-3xl font-serif font-bold text-earth-900" data-id="element-219">
                  Puntos que Sanan
                </h3>
                <p className="text-xl text-earth-600 font-serif italic" data-id="element-220">
                  Auriculoterapia práctica para desactivar síntomas físicos
                  naturalmente
                </p>
                <ul className="grid sm:grid-cols-2 gap-2.5" data-id="element-221">
                  {['Dolor físico', 'Tensión muscular', 'Sistema nervioso', 'Estrés acumulado', 'Ansiedad física', 'Sueño y descanso', 'Inflamación'].map((item, i) => <li key={i} className="flex items-center gap-2 text-earth-700" data-id="element-222">
                      <CheckCircle2 className="w-5 h-5 text-terracotta-500" data-id="element-223" />{' '}
                      {item}
                    </li>)}
                </ul>
              </div>
            </div>
          </div>

          <div className="flex justify-center pt-4" data-id="element-224">
            <ButtonCTA text="ACCEDER AHORA POR $16.990" subtext="85% OFF · Pago único · Acceso inmediato" showGuarantee data-id="element-225" />
          </div>
        </div>
      </section>

      {/* 6. Bonus Stack — RESTORED */}
      <section className="py-10 px-4 bg-earth-900 text-sand-50 relative overflow-hidden" data-id="element-226">
        <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-terracotta-900/30 rounded-full blur-[100px] pointer-events-none" data-id="element-227"></div>
        <div className="max-w-5xl mx-auto relative z-10" data-id="element-228">
          <div className="text-center mb-8" data-id="element-229">
            <h2 className="text-3xl sm:text-5xl font-serif font-bold text-white mb-3" data-id="element-230">
              Si te sumás hoy te llevás{' '}
              <span className="text-gold-500" data-id="element-231">6 BONUS GRATIS</span>
            </h2>
            <p className="text-lg text-earth-300" data-id="element-232">
              Herramientas extra para atacar el dolor desde todos los ángulos.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5" data-id="element-233">
            {[{
            num: 1,
            title: 'Rutina Anti-Tensión Nocturna',
            desc: 'Protocolo de 15 min para soltar cuello y mandíbula antes de dormir.'
          }, {
            num: 2,
            title: 'Plan 21 Días Sin Dolor',
            desc: 'Programa progresivo para reducir el dolor crónico paso a paso.'
          }, {
            num: 3,
            title: 'Fichas de Alivio Rápido',
            desc: 'Qué punto tocar según tu dolor — para frenarlo en minutos.'
          }, {
            num: 4,
            title: 'Mapa Completo de Puntos',
            desc: 'Todos los puntos de oído, manos y pies en un solo PDF.'
          }, {
            num: 5,
            title: 'Aceites para el Dolor',
            desc: 'Qué aceites esenciales potencian el alivio físico y cómo usarlos.'
          }, {
            num: 6,
            title: 'Tracker de Dolor Diario',
            desc: 'Registro para medir tu progreso y ver cómo baja la intensidad.'
          }].map((bonus, i) => <div key={i} className="bg-earth-800/50 border border-earth-700 p-5 rounded-2xl hover:bg-earth-800 transition-colors flex flex-col" data-id="element-234">
                <div className="flex items-center gap-3 mb-3" data-id="element-235">
                  <div className="w-9 h-9 rounded-full bg-gold-500/20 text-gold-500 flex items-center justify-center flex-shrink-0" data-id="element-236">
                    <Gift className="w-4 h-4" data-id="element-237" />
                  </div>
                  <h4 className="text-base font-serif font-bold text-white" data-id="element-238">
                    Bonus {bonus.num}
                  </h4>
                </div>
                <h5 className="text-lg font-bold text-sand-100 mb-1" data-id="element-239">
                  {bonus.title}
                </h5>
                <p className="text-earth-300 text-sm mb-4 flex-1" data-id="element-240">
                  {bonus.desc}
                </p>
                <div className="pt-3 border-t border-earth-700 flex justify-between items-center" data-id="element-241">
                  <span className="text-earth-400 text-xs line-through" data-id="element-242">
                    $11.990
                  </span>
                  <span className="text-gold-500 font-bold text-xs bg-gold-500/10 px-2.5 py-1 rounded-full" data-id="element-243">
                    HOY GRATIS
                  </span>
                </div>
              </div>)}
          </div>

          <div className="mt-12 flex justify-center" data-id="element-244">
            <ButtonCTA text="LLEVAR TODO POR $16.990" subtext="6 bonus GRATIS solo hoy · Garantía 7 días" showGuarantee data-id="element-245" />
          </div>
        </div>
      </section>

      {/* WhatsApp-style social proof wall */}
      <section className="py-10 px-4 bg-sand-100" data-id="element-246">
        <div className="max-w-5xl mx-auto" data-id="element-247">
          <div className="text-center mb-8" data-id="element-248">
            <p className="text-terracotta-700 text-xs sm:text-sm font-bold tracking-[0.2em] uppercase mb-2" data-id="element-249">
              Mensajes reales
            </p>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-earth-900 leading-tight" data-id="element-250">
              Lo que nos escriben{' '}
              <span className="italic text-terracotta-700" data-id="element-251">cada día</span>
            </h2>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5" data-id="element-252">
            {[{
            name: 'Mariana',
            time: '14:32',
            text: 'Cheee no lo puedo creer 🥹 me hice los puntos del oído antes de dormir y por primera vez en MESES no me levanté con la mandíbula apretada'
          }, {
            name: 'Pablo',
            time: '09:18',
            text: 'Mil gracias!!! Llevaba 3 semanas con el cuello durísimo. En 2 sesiones sentí la diferencia. Lo recomiendo a todos los del laburo'
          }, {
            name: 'Sole',
            time: '21:47',
            text: 'Tenía migraña desde el mediodía, abrí la ficha rápida y en 7 minutos me bajó. Sin pastillas. Estoy IMPACTADA 🙌'
          }, {
            name: 'Federico',
            time: '08:05',
            text: 'Me levanté HOY sin dolor de espalda después de meses. No sabés lo que es esto para mí, gracias en serio 🙏'
          }].map((m, i) => <div key={i} className="bg-white rounded-2xl shadow-sm border border-sand-200 overflow-hidden flex flex-col" data-id="element-253">
                <div className="bg-sage-50 border-b border-sand-200 px-4 py-2.5 flex items-center gap-2" data-id="element-254">
                  <div className="w-2 h-2 rounded-full bg-sage-500" data-id="element-255"></div>
                  <p className="text-xs font-semibold text-earth-700" data-id="element-256">
                    {m.name}
                  </p>
                  <span className="text-xs text-earth-400 ml-auto" data-id="element-257">
                    {m.time}
                  </span>
                </div>
                <div className="p-4 flex-1" data-id="element-258">
                  <p className="text-sm text-earth-800 leading-relaxed" data-id="element-259">
                    {m.text}
                  </p>
                  <p className="text-[10px] text-sage-600 text-right mt-2 font-semibold" data-id="element-260">
                    ✓✓ Leído
                  </p>
                </div>
              </div>)}
          </div>

          <p className="text-center text-xs text-earth-500 mt-6 italic" data-id="element-261">
            Mensajes recibidos por nuestras redes y mail · Identidades
            modificadas por privacidad
          </p>

          <div className="mt-10 flex justify-center" data-id="element-262">
            <ButtonCTA text="QUIERO MI ALIVIO POR $16.990" subtext="Sumate a las +2.000 personas · Garantía 7 días" showGuarantee data-id="element-263" />
          </div>
        </div>
      </section>

      {/* 9. FAQ Section */}
      <section className="py-10 px-4 bg-sand-50" data-id="element-264">
        <div className="max-w-4xl mx-auto" data-id="element-265">
          <div className="text-center mb-12" data-id="element-266">
            <h2 className="text-3xl sm:text-4xl font-serif font-bold text-earth-900 mb-4" data-id="element-267">
              Preguntas Frecuentes
            </h2>
          </div>

          <FAQAccordion items={[{
          question: '¿Y si no me funciona a mí?',
          answer: 'Tenés 7 días de garantía total. Si después de probar el método sentís que no es para vos, te devolvemos el 100% de tu dinero. Sin preguntas. Sin trabas.'
        }, {
          question: '¿Es complicado de usar?',
          answer: 'No. Cada práctica dura entre 5 y 15 minutos. Abrís el PDF, mirás la ficha de tu dolor, presionás el punto indicado. Así de simple.'
        }, {
          question: '¿Por qué tan barato si vale $111.920?',
          answer: 'Es precio de lanzamiento. Queremos que llegue a la mayor cantidad de personas posible. Cuando termine la promo, vuelve al valor real.'
        }, {
          question: '¿Cuándo recibo el producto?',
          answer: 'Inmediatamente después de la compra, en tu correo. Lo tenés para siempre.'
        }, {
          question: '¿Necesito agujas o materiales?',
          answer: 'No. Solo tus manos. Los aceites y semillas son opcionales.'
        }]} data-id="element-268" />

          <div className="mt-10 flex justify-center" data-id="element-269">
            <ButtonCTA text="LISTO, LO QUIERO POR $16.990" subtext="7 días de garantía total · Sin riesgo" showGuarantee data-id="element-270" />
          </div>
        </div>
      </section>

      {/* NEW: Value Stack — explicit price breakdown */}
      <section className="py-10 px-4 bg-gradient-to-b from-sand-50 to-sand-100" data-id="element-271">
        <div className="max-w-4xl mx-auto" data-id="element-272">
          <div className="text-center mb-10" data-id="element-273">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gold-500/20 border border-gold-500/40 text-earth-900 text-xs sm:text-sm font-bold tracking-wide uppercase mb-4" data-id="element-274">
              <Gift className="w-3.5 h-3.5 text-gold-600" data-id="element-275" />
              Todo lo que te llevás hoy
            </div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-earth-900 mb-4 leading-tight" data-id="element-276">
              Mirá <span className="text-terracotta-600 italic" data-id="element-277">todo</span> lo
              que te llevás para frenar el dolor
            </h2>
            <p className="text-lg text-earth-700 max-w-2xl mx-auto" data-id="element-278">
              Todo listo para usar desde tu casa, en 5 min al día. Valor real:{' '}
              <strong className="text-terracotta-700" data-id="element-279">$111.920</strong>.
            </p>
          </div>

          <div className="bg-white rounded-3xl shadow-xl border border-sand-200 overflow-hidden" data-id="element-280">
            {[{
            name: 'Ebook 1: Alivio en tus Manos (Reflexología)',
            desc: 'Protocolos paso a paso para dolor de cuello, espalda, cabeza y mandíbula',
            value: '$19.990'
          }, {
            name: 'Ebook 2: Puntos que Sanan (Auriculoterapia)',
            desc: 'Mapa exacto del oído para desactivar dolor y tensión',
            value: '$19.990'
          }, {
            name: 'Bonus 1: Rutina Anti-Tensión Nocturna',
            desc: 'Protocolo de 15 min para soltar cuello y mandíbula antes de dormir',
            value: '$11.990'
          }, {
            name: 'Bonus 2: Plan 21 Días Sin Dolor',
            desc: 'Programa progresivo para reducir el dolor crónico paso a paso',
            value: '$11.990'
          }, {
            name: 'Bonus 3: Fichas de Alivio Rápido',
            desc: 'Qué punto tocar según tu dolor — para frenarlo YA',
            value: '$11.990'
          }, {
            name: 'Bonus 4: Mapa Completo de Puntos',
            desc: 'Todos los puntos para dolor de cuello, mandíbula, cabeza y espalda',
            value: '$11.990'
          }, {
            name: 'Bonus 5: Aceites para el Dolor',
            desc: 'Aceites esenciales que potencian el alivio físico',
            value: '$11.990'
          }, {
            name: 'Bonus 6: Tracker de Dolor Diario',
            desc: 'Registro para medir tu progreso y ver cómo baja la intensidad',
            value: '$11.990'
          }].map((item, i) => <div key={i} className="grid grid-cols-12 gap-3 sm:gap-4 items-center p-4 sm:p-5 border-b border-sand-200 last:border-b-0" data-id="element-281">
                <div className="col-span-1" data-id="element-282">
                  <CheckCircle2 className="w-5 h-5 text-sage-600" data-id="element-283" />
                </div>
                <div className="col-span-8 sm:col-span-9" data-id="element-284">
                  <p className="font-bold text-earth-900 text-sm sm:text-base" data-id="element-285">
                    {item.name}
                  </p>
                  <p className="text-xs sm:text-sm text-earth-600" data-id="element-286">
                    {item.desc}
                  </p>
                </div>
                <div className="col-span-3 sm:col-span-2 text-right" data-id="element-287">
                  <span className="font-bold text-terracotta-700 text-sm sm:text-base" data-id="element-288">
                    {item.value}
                  </span>
                </div>
              </div>)}

            {/* Total row */}
            <div className="bg-earth-900 text-white p-5 sm:p-6" data-id="element-289">
              <div className="flex items-center justify-between flex-wrap gap-2" data-id="element-290">
                <span className="text-lg sm:text-xl font-bold" data-id="element-291">
                  Valor total real:
                </span>
                <span className="text-2xl sm:text-3xl font-black text-sand-300 line-through" data-id="element-292">
                  $111.920
                </span>
              </div>
            </div>

            {/* Price row */}
            <div className="bg-gradient-to-r from-gold-500/20 via-gold-500/30 to-gold-500/20 p-6 sm:p-8 text-center border-t-2 border-gold-500" data-id="element-293">
              <p className="text-sm font-bold uppercase tracking-[0.15em] text-earth-700 mb-2 flex items-center justify-center gap-2" data-id="element-294">
                <Flame className="w-4 h-4 text-terracotta-600" data-id="element-295" />
                Hoy lo llevás por
                <Flame className="w-4 h-4 text-terracotta-600" data-id="element-296" />
              </p>
              <div className="flex items-baseline justify-center gap-3" data-id="element-297">
                <span className="text-5xl sm:text-7xl font-black text-terracotta-700 leading-none" data-id="element-298">
                  $16.990
                </span>
                <span className="text-lg text-earth-700 font-bold" data-id="element-299">ARS</span>
              </div>
              <p className="text-earth-700 mt-3 font-semibold" data-id="element-300">
                Ahorrás <span className="text-terracotta-700" data-id="element-301">$94.930</span>{' '}
                <span className="text-earth-600" data-id="element-302">(85% OFF)</span> · Pago único ·
                Acceso inmediato
              </p>
            </div>
          </div>

          {/* Guarantee block */}
          <div className="mt-8 bg-white border-2 border-sage-300 rounded-3xl p-6 sm:p-8 flex items-center gap-5 sm:gap-6 max-w-3xl mx-auto" data-id="element-303">
            <div className="w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-sage-100 border-4 border-sage-300 flex flex-col items-center justify-center flex-shrink-0" data-id="element-304">
              <Award className="w-7 h-7 sm:w-8 sm:h-8 text-sage-700" data-id="element-305" />
              <span className="text-[10px] sm:text-xs font-black text-sage-800 mt-0.5" data-id="element-306">
                7 DÍAS
              </span>
            </div>
            <div data-id="element-307">
              <p className="font-serif text-lg sm:text-2xl font-bold text-earth-900 mb-1" data-id="element-308">
                Garantía total de 7 días
              </p>
              <p className="text-earth-700 text-sm sm:text-base" data-id="element-309">
                Probalo. Si en 7 días no sentís alivio, te devolvemos el{' '}
                <strong data-id="element-310">100% de tu dinero</strong>. Sin preguntas. Sin trabas.
                El riesgo lo asumimos nosotros.
              </p>
            </div>
          </div>

          <div className="mt-10 flex flex-col items-center gap-3" data-id="element-311">
            <ButtonCTA text="SÍ, LO QUIERO POR $16.990" subtext="85% OFF · Garantía 7 días · Pago único" showGuarantee data-id="element-312" />
            <p className="text-sm text-earth-600 flex items-center gap-2" data-id="element-313">
              <Lock className="w-4 h-4 text-sage-600" data-id="element-314" />
              Pago 100% seguro · Tarjeta, débito o efectivo
            </p>
          </div>
        </div>
      </section>

      {/* 10. Final CTA Section */}
      <section className="py-16 px-4 bg-earth-900 text-center relative overflow-hidden" data-id="element-315">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1515377905703-c4788e51af15?auto=format&fit=crop&q=80')] bg-cover bg-center opacity-10 mix-blend-overlay" data-id="element-316"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-earth-900 via-earth-900/80 to-transparent" data-id="element-317"></div>

        <div className="max-w-3xl mx-auto relative z-10 space-y-6" data-id="element-318">
          {/* Urgency banner */}
          <div className="inline-flex items-center gap-2 bg-terracotta-600/30 border border-terracotta-500 text-terracotta-100 px-4 py-2 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-319">
            <Flame className="w-4 h-4 text-gold-500 animate-pulse" data-id="element-320" />
            Última oportunidad a este precio
            <Flame className="w-4 h-4 text-gold-500 animate-pulse" data-id="element-321" />
          </div>

          <h2 className="text-4xl sm:text-5xl font-bold text-sand-50 leading-tight" data-id="element-322">
            Hoy podés decidir{' '}
            <span className="italic text-terracotta-300" data-id="element-323">
              cómo va a ser mañana.
            </span>
          </h2>

          <p className="text-xl text-sand-100 max-w-xl mx-auto leading-relaxed" data-id="element-324">
            Otra noche con la mandíbula apretada y el cuello duro. O un método
            que ya alivió a +2.000 personas{' '}
            <strong className="text-gold-400" data-id="element-325">
              por menos de lo que cuesta una sesión de kine.
            </strong>
          </p>

          {/* Hero countdown */}
          <div className="bg-earth-800/60 border border-gold-500/30 rounded-2xl p-4 max-w-md mx-auto" data-id="element-326">
            <p className="text-gold-500 text-xs font-bold uppercase tracking-[0.15em] mb-2 flex items-center justify-center gap-2" data-id="element-327">
              <Clock className="w-3.5 h-3.5 animate-pulse" data-id="element-328" /> La oferta termina
              en
            </p>
            <CountdownTimer data-id="element-329" />
          </div>

          <div className="bg-white/10 backdrop-blur-sm p-8 rounded-3xl border border-white/20 max-w-xl mx-auto" data-id="element-330">
            <p className="inline-flex items-center gap-2 bg-gold-500 text-earth-900 px-4 py-1.5 rounded-full font-bold mb-4 text-sm uppercase tracking-wider" data-id="element-331">
              <Flame className="w-4 h-4" data-id="element-332" />
              85% OFF · Solo 14 cupos
            </p>
            <p className="text-lg text-sand-200 mb-2" data-id="element-333">
              Bundle completo + 6 bonus por:
            </p>
            <div className="flex items-baseline justify-center gap-3 mb-2" data-id="element-334">
              <span className="text-xl text-sand-300/70 line-through" data-id="element-335">
                $111.920
              </span>
              <span className="text-6xl sm:text-7xl font-black text-gold-500 leading-none" data-id="element-336">
                $16.990
              </span>
              <span className="text-lg text-sand-300" data-id="element-337">ARS</span>
            </div>
            <p className="text-sand-300 mb-6 text-sm" data-id="element-338">
              Pago único · Acceso inmediato · Garantía 7 días
            </p>
            <ButtonCTA text="QUIERO EL BUNDLE POR $16.990" className="!w-full" data-id="element-339" />

            {/* Trust row */}
            <div className="mt-5 flex items-center justify-center gap-4 text-xs text-sand-300 flex-wrap" data-id="element-340">
              <span className="flex items-center gap-1.5" data-id="element-341">
                <Lock className="w-3.5 h-3.5 text-sage-400" data-id="element-342" /> Pago seguro
              </span>
              <span className="flex items-center gap-1.5" data-id="element-343">
                <Download className="w-3.5 h-3.5 text-sage-400" data-id="element-344" /> Acceso
                inmediato
              </span>
              <span className="flex items-center gap-1.5" data-id="element-345">
                <ShieldCheck className="w-3.5 h-3.5 text-sage-400" data-id="element-346" /> Garantía 7
                días
              </span>
            </div>
          </div>

          {/* Final risk reversal */}
          <p className="text-sm text-earth-400 max-w-md mx-auto pt-2" data-id="element-347">
            Si en 7 días no sentís diferencia, te devolvemos el 100%. Literal:
            no podés perder.
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-earth-950 text-earth-500 py-8 text-center text-sm" data-id="element-348">
        <p data-id="element-349">
          © {new Date().getFullYear()} Bienestar Digital. Todos los derechos
          reservados.
        </p>
        <p className="mt-2 text-xs max-w-2xl mx-auto px-4" data-id="element-350">
          Este producto no sustituye el consejo médico profesional. Consulte a
          su médico antes de comenzar cualquier programa de bienestar.
        </p>
      </footer>

      {/* Floating urgency components */}
      <RecentPurchaseToast data-id="element-351" />
    </div>;
}